import React from 'react';

const Button = ({  
    className = '',
    title = 'Shop Now',  
    onClick
}) => {  
    return (  
        <button  
        onClick={onClick}
            className={`inline-flex min-h-11 items-center justify-center rounded-lg bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${className}`}
        >  
    
            {title}  
        </button>  
    );  
};  

export default Button;
